// Dependencies
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: #fff;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  max-width: 1366px;
  padding-inline: 24px;
  padding-block: 40px;

  @media (min-width: 768px) {
    padding-inline: 40px;
    gap: 40px;
  }

  @media (min-width: 1366px) {
    padding-inline: 71px;
  }

  @media (min-width: 1920px) {
    padding-inline: 0;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const LogoImage = styled.img`
  display: block;
  width: fit-content;
`

export const SocialNetworksWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const SocialNetworkItemLink = styled.a`
  display: block;
`

export const SocialNetworkItemIcon = styled.img`
  display: block;
`

export const FooterLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const FooterLinksContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const LinksTitle = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: #25272d;
`

export const LinkItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 240px;
`

export const LinkItem = styled.a`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #666b7b;
`

export const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const FooterPaymentsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const PaymentItem = styled.img`
  display: block;
  max-width: 170px;
`

export const AddressWrapper = styled.div`
  display: block;
  padding-top: 40px;
  border-top: 1px solid #ced0dd;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #666b7b;

  @media (min-width: 1366px) {
    padding-top: 24px;
  }
`
